export const rulesName = [
  'date',
  'website',
  'IDCard',
  'phoneNumber',
  'telephoneNumber',
  'qqNumber',
  'emial'
]

export const starMap = ['满意', '认同', '重要', '愿意', '符合']

export const _DOMAIN = getDomain()

export const defaultThemeColor = '#ff552d'

function getDomain() {
  let location = window.location
  let prefix = location.protocol + '//'
  if (location.host === 'survey.58corp.com') {
    return prefix + 'survey.58corp.com/oa'
  } else {
    // return prefix + 'survey.58.com'
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/utils/constant.js